export enum ReminderMessageType {
  Custom = 'CUSTOM',
  Appointment = 'APPOINTMENT',
}

export enum ReminderSortField {
  StartDate = 'startDate',
  LastSendDate = 'lastSendDate',
  NextSendDate = 'nextSendDate',
  PatientName = 'patientName',
}
